import image1 from '../../images/Funcions2_1.webp'
import image2 from '../../images/Funcions2_2.webp'
import image3 from '../../images/Funcions2_3.webp'

import styles from './Transcripcio.module.css'

const Transcripcio = () => {

    return (
        <div className={styles.container}>
            <section className={styles.heroImageContainer}>
                <img src={image1} alt="Transtorma digitalment els seguiments" className={styles.heroImage}/>
                <h1 className={styles.titleImage}>De veu a text. Endinça't a un nou nivell de l'atenció a les persones</h1>
                <h2 className={styles.titleImage2}><a href="mailto:codelabosona@gmail.com" className={styles.emailLink}><span>Informa't com</span><i className="fa-solid fa-arrow-right"></i></a></h2>
            </section>
            <section className={`${styles.section} ${styles.sectionFirst}`}>
                <div className={styles.section2}>
                    <img src={image2} alt="Transtorma digitalment els seguiments" className={styles.images}/>
                </div>
                <div className={styles.section1}>
                    <ul>
                        <li>Realitza els seguiment de veu</li>
                        <li>Socialin permet enregistrar els seguiments de les persones ateses des del mateix lloc on es realitza.</li>
                        <li>Redueix el 100% del temps administratiu</li>
                        <li>La transcripció de veu permet reduir totalment el temps dedicat a enregistrar els seguiments en els softwares, excels o plantilles de seguiments.</li>
                        <li>Dedica't a l'atenció a les persones</li>
                        <li>Redueix el temps administratiu dels professionals de la teva organització que roba temps a l'atenció a les persones.</li>
                    </ul>
                </div>
            </section>
            <section className={`${styles.section} ${styles.sectionSecond}`}>
                <div className={styles.section1}>
                    <h2>Aplicació de mòvil o Telegram: utilitza la plataforma que millor creguis.</h2> 
                    <p>La utilizació de diferents plantaformes permet que l'adopció d'aquesta tecnologia sigui més fàcil.</p>
                    <a href="mailto:codelabosona@gmail.com" className={styles.emailLink}><span>Informa't com</span><i className="fa-solid fa-arrow-right"></i></a>
                </div>
                <div className={styles.section2}>
                    <img src={image3} alt="Transtorma digitalment els seguiments" className={styles.images}/>
                </div>       
            </section>
        </div>
    )
}

export default Transcripcio